import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { adminApi, api } from "@/lib/api";

const FIELDS = [
  ["company_name", "Company name"],
  ["address_line1", "Address line 1"],
  ["address_line2", "Address line 2"],
  ["phone", "Phone"],
  ["email_primary", "Primary email"],
  ["email_secondary", "Secondary email"],
  ["linkedin", "LinkedIn URL"],
  ["notification_emails", "Enquiry notification emails (comma separated)"],
];

export default function AdminSettings() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data)).catch(() => toast.error("Failed to load settings"));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.put("/admin/settings", form);
      toast.success("Company settings saved");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  if (!form) return <p className="text-sm text-neutral-400">Loading…</p>;

  return (
    <div data-testid="admin-settings-page" className="max-w-2xl">
      <h1 className="text-xl font-semibold text-neutral-900">Company Settings</h1>
      <p className="text-sm text-neutral-500 mt-0.5">Contact details shown in the footer and on the Contact page.</p>

      <form onSubmit={save} className="mt-6 bg-white border border-neutral-200 p-6 space-y-4">
        {FIELDS.map(([key, label]) => (
          <div key={key} className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wider text-neutral-500">{label}</Label>
            <Input
              value={form[key] || ""}
              onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
              data-testid={`settings-${key.replace(/_/g, "-")}-input`}
            />
          </div>
        ))}
        <div className="space-y-1.5">
          <Label className="text-xs uppercase tracking-wider text-neutral-500">Footer statement</Label>
          <Textarea
            rows={3}
            value={form.footer_statement || ""}
            onChange={(e) => setForm((f) => ({ ...f, footer_statement: e.target.value }))}
            data-testid="settings-footer-statement-input"
          />
        </div>
        <Button type="submit" disabled={busy} className="bg-[#4B0F1E] hover:bg-[#3a0c17]" data-testid="settings-save-btn">
          {busy ? "Saving…" : "Save settings"}
        </Button>
      </form>
    </div>
  );
}
